export default __webpack_public_path__ + "static/media/Flag_of_Malaysia.be20c8a5.svg";